import React from "react";
import PropTypes from "prop-types";
import { Col, Button } from "reactstrap";

const propTypes = {
  client: PropTypes.shape({
    email: PropTypes.string,
    full_name: PropTypes.string
  }).isRequired,
  toggleEdit: PropTypes.func.isRequired
};

const ShowClient = ({ client, toggleEdit }) => {
  return (
    <Col className="d-flex align-items-center">
      <span className="p-0 mr-2">
        {client.full_name}, {client.email}&nbsp;
      </span>
      <Button color="link" className="border-0 p-0" onClick={toggleEdit}>
        edit
      </Button>
    </Col>
  );
};

ShowClient.propTypes = propTypes;

export default ShowClient;
